import Model from '@/core/models/Model';
import Restriction from '@/models/Restriction';
import type { Restriction as IRestriction } from '@/types/Restriction';

class RestrictionService {
  getRestrictions(search: string = '') {
    return useAsyncData<IRestriction[]>(
      'restrictions',
      async () => {
        const restriction = new Restriction();
        if (search) {
          restriction.where('search', search);
        }

        return Model.processResponse(await restriction.get()) as IRestriction[];
      },
      { server: false }
    );
  }
}

const service = new RestrictionService();
export default service;
